module.exports = __webpack_public_path__ + "347b60cf985684d7ea4ff2ffae61c549.svg";